// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__ohw4m","inputDescription":"styles_inputDescription__pF0nq"};